import { Metamodel } from 'app/model/base/model';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';
import { SnowflakeSettings } from './snowflake-settings';
import { SnowflakeV2TableDataset } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.snowflakeV2.dataflowSettings
})
export class SnowflakeV2Settings extends SnowflakeSettings {
    public override getFormat(): DatasetFormatType {
        return DatasetFormatType.SnowflakeV2;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(SnowflakeV2TableDataset).name
    }
}